/** @file The 'b' update op: one bone's world from its applied values, parent world and inherit code. */
import { POSE_LAYOUT, type Pose } from '../contracts/pose';
import type { InheritMode, SkeletonData } from '../skeletonData';
import { localToWorld } from './localToWorld';

/** Module scratch: a copy of the parent world and the result (no subarray views, so nothing is allocated). */
const parentWorld = new Float64Array(POSE_LAYOUT.WORLD_STRIDE);
const boneWorld = new Float64Array(POSE_LAYOUT.WORLD_STRIDE);

/**
 * pose.world[bone] = localToWorld(pose.applied[bone], pose.world[parent] or root, pose.inherit[bone]). Reads the
 * parent's current world, so callers run it in update order; IK solvers call it to recompute their bones.
 */
export function updateBoneWorld(pose: Pose, data: SkeletonData, bone: number): void {
  const stride = POSE_LAYOUT.WORLD_STRIDE;
  const parent = data.bones[bone]?.parent ?? -1;
  if (parent >= 0) {
    for (let k = 0; k < stride; k++) parentWorld[k] = pose.world[parent * stride + k] ?? 0;
  }
  const inherit = (pose.inherit[bone] ?? 0) as InheritMode;
  localToWorld(boneWorld, pose.applied, bone * POSE_LAYOUT.LOCAL_STRIDE, parent >= 0 ? parentWorld : null, inherit);
  pose.world.set(boneWorld, bone * stride);
}
